import { formatBookingCurrency } from './formatBookingCurrency';

export type BookingPaymentStatusValue =
  | 'Opłacona'
  | 'Częściowo opłacona'
  | 'Nieopłacona'
  | 'Nadpłata';

export const normalizeBookingPaymentStatus = (
  status?: string
): BookingPaymentStatusValue | (string & {}) => {
  const trimmed = (status ?? '').trim();
  if (trimmed.startsWith('Częściowo opłacona')) return 'Częściowo opłacona';
  if (trimmed.startsWith('Nadpłata')) return 'Nadpłata';
  return trimmed;
};

export const getBookingPaymentStatusColor = (
  status?: BookingPaymentStatusValue | string
): 'default' | 'warning' | 'success' | 'error' | 'info' => {
  const normalized = normalizeBookingPaymentStatus(status ?? '');
  if (!normalized || normalized === 'Nieopłacona') return 'error';
  if (normalized === 'Częściowo opłacona') return 'warning';
  if (normalized === 'Opłacona') return 'success';
  if (normalized === 'Nadpłata') return 'info';
  return 'default';
};

export const formatBookingPaymentStatusLabel = (
  status: BookingPaymentStatusValue | string,
  totalPrice: number,
  totalPaidAmount: number
): string => {
  const normalized = normalizeBookingPaymentStatus(status);
  if (normalized === 'Częściowo opłacona') {
    const remaining = Math.max(0, totalPrice - totalPaidAmount);
    return `Częściowo opłacona (${formatBookingCurrency(remaining)})`;
  }
  if (normalized === 'Nadpłata') {
    const overpaid = Math.max(0, totalPaidAmount - totalPrice);
    return `Nadpłata (${formatBookingCurrency(overpaid)})`;
  }
  return normalized || 'Nieopłacona';
};

export const getBookingPaymentStatusAmount = (
  status: BookingPaymentStatusValue | string,
  totalPrice: number,
  totalPaidAmount: number
): string | null => {
  const normalized = normalizeBookingPaymentStatus(status);
  if (normalized === 'Częściowo opłacona') {
    const remaining = Math.max(0, totalPrice - totalPaidAmount);
    return formatBookingCurrency(remaining);
  }
  if (normalized === 'Nadpłata') {
    const overpaid = Math.max(0, totalPaidAmount - totalPrice);
    return formatBookingCurrency(overpaid);
  }
  return null;
};
